import './PreFooter.scss';
import { useNavigate } from 'react-router-dom';
import Back from './bg.jpg';
import Button from '../Button';

const PreFooter = ({ title, text, mainButtonText, onMainClick, background = Back }) => {
  const navigate = useNavigate();

  return (
    <div className='preFooter'>
      <span className='preFooterBackground'>
        <img src={background} />
      </span>
      <h1 className='preFooterTitle'>{title}</h1>
      <span className='preFooterText'>{text}</span>
      <Button text={mainButtonText} onClick={onMainClick} type='primary' />
    </div>
  );
};

export default PreFooter;
